//
// ClassificationRole.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./Role";

var ClassificationRole = createModule("gtl::ClassificationRole", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::Role"], EventDispatcher, [
    ,
    ,
    ,
    ,
    ,
    {
        _create_v: [4],
        _create_s: [4,7],
        _create_o: [4,1],
    },
    ,
    ["_create"]
]);
export default ClassificationRole;
